module.exports = __webpack_public_path__ + "0eb8cd311673cfaab900fe71acddad02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/organizations/bespoke_bg@3x.jpg
// module id = 658
// module chunks = 0